if (!customElements.get("jky-pdp-v4-detail-scene")) {
  customElements.define(
    "jky-pdp-v4-detail-scene",
    class jkyPdpDetailScene extends HTMLElement {
      constructor() {
        super();
        this.lastScrollTop = 0;
        this.scrollDirection = "down"; // 默认当前滚动方向向下
        this.animationStart = false; // 记录交互开始

        this.textItems = this.querySelectorAll("[data-text-item]");
        this.imageItems = this.querySelectorAll("[data-image-item]");

        if (this.textItems.length > 0 && this.imageItems.length > 0) {
          // 更新滚动方向
          window.addEventListener("scroll", () => {
            let scrollTop =
              window.scrollY || document.documentElement.scrollTop;

            if (
              scrollTop > this.lastScrollTop &&
              this.scrollDirection !== "down"
            ) {
              // 向下滚动
              this.scrollDirection = "down";
            } else if (
              scrollTop < this.lastScrollTop &&
              this.scrollDirection !== "up"
            ) {
              // 向上滚动
              this.scrollDirection = "up";
              this.animationStart = true;
            }

            this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // 防止负值
          });

          this.init();
        }
      }
      init() {
        this.textItems.forEach((item) => {
          const Observer = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.textItems.forEach((t) =>
                    t.classList.remove("opacity-100")
                  );
                  entry.target.classList.add("opacity-100");

                  // 更新图片显示
                  const index = entry.target.dataset.index;
                  const currentImgDOM = this.querySelector(
                    `[data-image-item][data-index="${index}"]`
                  );
                  if (
                    currentImgDOM &&
                    currentImgDOM.dataset.imageConfig === "true"
                  ) {
                    this.imageItems.forEach((t) =>
                      t.classList.remove("opacity-100")
                    );
                    currentImgDOM.classList.add("opacity-100");
                  }
                } else {
                  entry.target.classList.remove("opacity-100");

                  // 如果全部都置灰了，则将第一个或最后一个高亮
                  if (!this.querySelector("[data-text-item].opacity-100")) {
                    const idx =
                      this.scrollDirection == "down" && this.animationStart
                        ? this.textItems.length - 1
                        : 0;
                    this.textItems[idx].classList.add("opacity-100");
                  }
                }
              });
            },
            {
              root: null,
              rootMargin: "0px",
              threshold: 0.8,
            }
          );

          Observer.observe(item);
        });
      }
    }
  );
}
